import { memo, useCallback } from 'react'
import replaceBrowserHistory from '@pancakeswap/utils/replaceBrowserHistory'
import { useTranslation } from '@pancakeswap/localization'
import { useSwapActionHandlers } from '@/state/swap/useSwapActionHandlers'
import { useSwapState } from '@/state/swap/hooks'
import { Field } from '@/state/swap/actions'
import { useAllowRecipient } from '../hooks'
import { ArrowUpDownIcon } from 'lucide-react'

export const FlipButton = memo(function FlipButton() {
  const { t } = useTranslation()
  const { onSwitchTokens, onChangeRecipient } = useSwapActionHandlers()
  const {
    recipient,
    [Field.INPUT]: { currencyId: inputCurrencyId },
    [Field.OUTPUT]: { currencyId: outputCurrencyId },
  } = useSwapState()
  const allowRecipient = useAllowRecipient()

  const onFlip = useCallback(() => {
    onSwitchTokens()
    replaceBrowserHistory('inputCurrency', outputCurrencyId)
    replaceBrowserHistory('outputCurrency', inputCurrencyId)
  }, [onSwitchTokens, inputCurrencyId, outputCurrencyId])

  return (
    <div>
      <div
        className={
          'w-13 h-13 rounded-2xl flex items-center justify-center border-8 border-background bg-zap cursor-pointer'
        }
      >
        <ArrowUpDownIcon onClick={onFlip} className={'w-6 h-6 font-bold text-background'} />
      </div>
    </div>
  )
})
